<div class="flex flex-col flex-auto min-w-0">


  <!-- Main -->
  <div class="flex border-t pt-4 sm:pt-6">
    <div *ngIf="showRecoveryButton && eventsToRecovery.length > 0" class="w-1/4 pr-4 pl-8">

      <p class="text-xl font-semibold">Sesiones a recuperar</p>
      <div *ngFor="let event of eventsToRecovery"
           class="bg-card shadow rounded-2xl p-4 flex items-center justify-between mb-4">

        <div>
          <p *ngFor="let client of event.clientsId">
            <strong>
              {{ clientsObject[client].name + ' ' + clientsObject[client].lastname1 + ' ' + clientsObject[client].lastname2 }}
            </strong>
          </p>
          <p>
            {{ event.start | date: "E d 'de' MMMM" }}
          </p>
          <p>
            {{ event.start | date: "'De' HH:mm" }} a {{ event.end | date: 'HH:mm' }}
          </p>
        </div>
        <div *ngIf="showRecoveryButton && user.isAdmin">
          <mat-icon (click)="showDetail(event)" svgIcon="mat_outline:edit_calendar"></mat-icon>
        </div>

      </div>

    </div>
    <div class="w-full relative">
      <button (click)="showRecoveryButton = !showRecoveryButton" *ngIf="!isMobile && eventsToRecovery.length > 0"
              class="absolute left-8 z-99" mat-raised-button>
        Recuperaciones Pendientes
      </button>

      <!-- Tabs -->
      <mat-tab-group
        (selectedIndexChange)="changeView($event)"
        [selectedIndex]="selectedIndex"
        class="p-2"
        dynamicHeight
        mat-align-tabs="center"
      >

        <!-- Home -->
        <mat-tab label="Semanal">
          <ng-template matTabContent>
            <div class="flex flex-col md:flex-row justify-between gap-4">
              <div class="mt-4 flex gap-2 overflow-auto py-2">
                <ng-container *ngFor="let user of users">
                  <app-avatar-photo
                    (click)="changeUser(user)"
                    *ngIf="user.services?.length > 0"
                    [active]="selectedUsers.indexOf(user?.id) !== -1"
                    [color]="user.color"
                    [name]="user.name"
                  ></app-avatar-photo>
                </ng-container>
                <app-avatar-photo
                  (click)="filterByFirstInterview()"
                  [active]="isFilterByFirstInterview"
                  [color]="'red'"
                  [name]="'1E'"
                ></app-avatar-photo>
              </div>

              <app-client-finder (search)="onSubmit($event)"></app-client-finder>
            </div>


            <div class="my-6 justify-center">
              <app-calendar-header
                (viewDateChange)="viewDateChange($event)"
                [(view)]="view"
                [viewDate]="viewDate"
              >
              </app-calendar-header>
              <div class="flex justify-center">
                <button (click)="showMorningSchedule()" mat-raised-button>{{ dayStartHour < 16 ? 'Cerrar' : 'Ver' }}
                  horario de mañana
                </button>
              </div>
            </div>

            <div class="flex w-480 md:w-full mb-6">
              <ng-template
                #weekViewHourSegmentTemplate
                let-isTimeLabel="isTimeLabel"
                let-locale="locale"
                let-segment="segment"
                let-segmentHeight="segmentHeight"
              >
                <div
                  #segmentElement
                  (mousedown)="(user.isAdmin && !isMobile) ? startDragToCreate(segment, $event, segmentElement) : null"
                  [class.cal-after-hour-start]="!segment.isStart"
                  [class.cal-hour-start]="segment.isStart"
                  [ngClass]="segment.cssClass"
                  [style.height.px]="segmentHeight"
                  class="cal-hour-segment"
                >
                  <div *ngIf="isTimeLabel">
                    <span *ngIf="(segment.date | date:'mm') === '00'" class="text-xl ml-2">
                      {{ segment.date | calendarDate:'weekViewHour':locale }}
                    </span>
                    <span *ngIf="(segment.date | date:'mm') !== '00'" class="ml-7">
                      :{{ segment.date | date: 'mm' }}
                    </span>
                  </div>
                </div>
              </ng-template>
              <mwl-calendar-week-view
                (beforeViewRender)="updateCalendarEvents($event)"
                (eventClicked)="showDetail($event.event.meta.event)"
                [dayEndHour]="21"
                [dayStartHour]="dayStartHour"
                [events]="events"
                [excludeDays]="[0,6]"
                [hourSegmentTemplate]="weekViewHourSegmentTemplate"
                [hourSegments]="4"
                [viewDate]="viewDate"
                class="w-full"
              >
              </mwl-calendar-week-view>
            </div>
          </ng-template>
        </mat-tab>
        <!-- Home -->
        <mat-tab label="Diaria">
          <ng-template matTabContent>
            <ng-template
              #weekViewHourSegmentTemplate
              let-isTimeLabel="isTimeLabel"
              let-locale="locale"
              let-segment="segment"
              let-segmentHeight="segmentHeight"
            >
              <div
                #segmentElement
                (mousedown)="(user.isAdmin && !isMobile) ? startDragToCreate(segment, $event, segmentElement) : null"
                [class.cal-after-hour-start]="!segment.isStart"
                [class.cal-hour-start]="segment.isStart"
                [ngClass]="segment.cssClass"
                [style.height.px]="segmentHeight"
                class="cal-hour-segment"
              >
                <div *ngIf="isTimeLabel">
                  <span *ngIf="(segment.date | date:'mm') === '00'" class="text-xl ml-2">
                    {{ segment.date | calendarDate:'weekViewHour':locale }}
                  </span>
                  <span *ngIf="(segment.date | date:'mm') !== '00'" class="ml-7">
                    :{{ segment.date | date: 'mm' }}
                  </span>
                </div>
              </div>
            </ng-template>
            <div class="flex gap-2 py-2 mt-4">
              <ng-container *ngFor="let user of users">
                <app-avatar-photo
                  (click)="changeUser(user)"
                  *ngIf="user.services?.length > 0"
                  [active]="selectedUsers.indexOf(user?.id) !== -1"
                  [color]="user.color"
                  [name]="user.name"
                ></app-avatar-photo>
              </ng-container>
              <app-avatar-photo
                (click)="filterByFirstInterview()"
                [active]="isFilterByFirstInterview"
                [color]="'red'"
                [name]="'1E'"
              ></app-avatar-photo>
            </div>

            <div class="my-6">
              <app-calendar-header
                (viewDateChange)="viewDateChange($event)"
                [(view)]="view"
                [viewDate]="viewDate"
              >
              </app-calendar-header>
              <div class="flex justify-center">
                <button (click)="showMorningSchedule()" mat-raised-button>{{ dayStartHour < 16 ? 'Cerrar' : 'Ver' }}
                  horario de mañana
                </button>
              </div>
            </div>

            <mwl-calendar-day-view
              (beforeViewRender)="updateCalendarEvents($event)"
              (eventClicked)="showDetail($event.event.meta.event)"
              [dayEndHour]="21"
              [dayEndMinute]="0"
              [dayStartHour]="dayStartHour"
              [events]="events"
              [hourDuration]="15"
              [hourSegmentTemplate]="weekViewHourSegmentTemplate"
              [hourSegments]="1"
              [viewDate]="viewDate"
            >
            </mwl-calendar-day-view>
          </ng-template>
        </mat-tab>

      </mat-tab-group>
    </div>
  </div>

</div>

<ng-template #dialogDeleteType>
  <h2 class="text-center" matDialogTitle>Opciones de borrado</h2>
  <mat-dialog-content style="height: calc(100% - 68px - 32px);">
    <form [formGroup]="deleteForm" class="h-full justify-between">
      <mat-radio-group class="w-full flex flex-col justify-center" formControlName="deleteType">
        <mat-radio-button [value]="1" class="mt-2">Borrar toda la serie</mat-radio-button>
        <mat-radio-button [value]="2" class="mt-2">Borrar este evento y posteriores de la serie</mat-radio-button>
        <mat-radio-button [value]="3" class="mt-2">Borrar solo este evento</mat-radio-button>
      </mat-radio-group>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="justify-center">
    <button [matDialogClose]="true" color="primary" mat-raised-button>
      Borrar
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #dialogEditType let-data>
  <h2 class="text-center" matDialogTitle>Opciones de modificado</h2>
  <mat-dialog-content style="height: calc(100% - 68px - 32px);">
    <form [formGroup]="editForm" class="h-full justify-between">
      <mat-radio-group class="w-full flex flex-col justify-center" formControlName="editType">
        <mat-radio-button *ngIf="!data.event.oldStart" [value]="1" class="mt-2">Cambiar toda la serie</mat-radio-button>
        <mat-radio-button *ngIf="!data.event.oldStart" [value]="2" class="mt-2">Cambiar este evento y posteriores de la
          serie
        </mat-radio-button>
        <mat-radio-button [value]="3" class="mt-2">Cambiar solo este evento</mat-radio-button>
      </mat-radio-group>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="justify-center">
    <button [matDialogClose]="true" color="primary" mat-raised-button>
      Modificar
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #dialogCancelType>
  <h2 class="text-center" matDialogTitle>Cancelar sesión</h2>
  <mat-dialog-content style="height: calc(100% - 68px - 32px);">
    <form [formGroup]="cancelForm">
      <formly-form [fields]="fields"
                   [form]="cancelForm"
                   [model]="model"></formly-form>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="justify-center">
    <button [disabled]="cancelForm.invalid" [matDialogClose]="true" color="primary" mat-raised-button>
      Cancelar
    </button>
  </mat-dialog-actions>
</ng-template>
